<section data-step="0" class="step">
        <div class="newchapter">   
            <h1 class="chapter">Alles* over je <i class="mark">studieschuld</i>, simpel uitgelegd</h1>
            <h2 class="chaptersubtitle">*als je onder het leenstelsel valt</h2>
        </div>
        <div class="row">       
            <div class="six columns">
                <h2>Waarom deze website?</h2>
                <p>Hier volgt een onpopulaire mening: het leenstelsel is eigenlijk best ok. Het is vooral enorm lastig om te zien welke impact jouw schuld heeft in de toekomst. Deze website helpt je </p>
            </div>
            <div class="six columns">
                <h2>Eerst even dit</h2>
                <p>Op deze website vind je een uitleg over alles wat met je studieschuld te maken heeft. Ik hoop dat deze website je helpt om te begrijpen hoe het systeem werkt en waar je op moet letten bij het lenen van geld voor je studie.</p>
                <p>🔒 Even over privacy: als je iets invult op deze site (bijvoorbeeld je schuld of hoe lang je studeert) blijft die informatie op jouw computer **tenzij** je aangeeft dat ik de informatie mag gebruiken. Zo kan ik je bijvoorbeeld een gemiddelde laten zien van wat de meeste studenten hebben ingevuld. In dat geval verstuur je die informatie op zo’n manier dat deze nooit meer aan jou te koppelen is.</p>
            </div>
        </div>
</section>
